{
  "app": {
    "nom": "Recorregut",
    "carregant": "Cargando",
    "tancar": "Cerrar",
    "cancellar": "Cancelar",
    "desar": "Guardar",
    "reintentar": "Volver a intentarlo",
    "saltarAlContingut": "Saltar al contenido principal"
  },
  "idioma": {
    "canviar": "Cambiar de idioma"
  },
  "navegacio": {
    "mapa": "Mapa",
    "classificacio": "Clasificación",
    "menu": "Menú principal"
  },
  "sessio": {
    "iniciada": "Sesión iniciada. Ya podéis empezar el recorrido.",
    "noValida": "Este código QR no es válido. Comprobad el enlace del correo.",
    "sortir": "Cerrar la sesión",
    "sensesessio": "No habéis iniciado ninguna sesión",
    "sensesessioDetall": "Podéis consultar el mapa y los puntos. Para responder las preguntas hay que inscribirse en un evento y escanear el código QR que recibiréis por correo."
  },
  "mapa": {
    "precisio": "Precisión aproximada de {{metres}}",
    "descripcio": "Mapa con los puntos del recorrido. Si usáis un lector de pantalla, la lista de puntos que hay debajo contiene la misma información en formato accesible."
  },
  "geolocalitzacio": {
    "activar": "Activar la ubicación",
    "explicacio": "Para detectar cuándo llegáis a un punto hace falta acceso a la ubicación. La aplicación solo la usa mientras la tenéis abierta y no la guarda en ningún sitio.",
    "denegada": "Habéis denegado el acceso a la ubicación. Podéis activarlo desde los ajustes del navegador.",
    "noDisponible": "Este dispositivo no permite obtener la ubicación.",
    "error": "No se ha podido obtener la ubicación.",
    "cercant": "Buscando la ubicación",
    "activa": "Ubicación activa",
    "pantallaEncesa": "La pantalla se mantendrá encendida mientras hacéis el recorrido"
  },
  "punt": {
    "distancia": "A {{distancia}}",
    "arribat": "Ya estáis aquí",
    "visitat": "Visitado",
    "noVisitat": "Pendiente",
    "respost": "Respondido",
    "sensVideo": "Este punto todavía no tiene vídeo.",
    "acostarse": "Acercaos a menos de {{radi}} para activar este punto.",
    "llistaTitol": "Puntos del recorrido",
    "cap": "Todavía no hay puntos publicados.",
    "variosTitol": "Estáis cerca de varios puntos",
    "variosAjuda": "Tocad el punto en el que estáis ahora mismo."
  },
  "video": {
    "titol": "Vídeo del punto",
    "reproduir": "Reproducir el vídeo",
    "silenciat": "El vídeo empieza sin sonido porque el navegador no permite arrancarlo con audio automáticamente. Pulsad el icono de sonido para activarlo.",
    "bloquejat": "El navegador ha bloqueado la reproducción automática. Pulsad el botón para ver el vídeo.",
    "descripcio": "Descripción del contenido",
    "noCompatible": "Vuestro navegador no puede reproducir este vídeo.",
    "subtitols": "Subtítulos",
    "activarSo": "Activar el sonido"
  },
  "pregunta": {
    "titol": "Pregunta",
    "respondre": "Enviar la respuesta",
    "capSeleccionada": "Hay que elegir una opción antes de enviar.",
    "intentUnic": "Solo tenéis un intento. Una vez enviada, la respuesta no se puede cambiar.",
    "correcta": "Respuesta correcta",
    "incorrecta": "Respuesta incorrecta",
    "puntsObtinguts_one": "{{punts}} punto",
    "puntsObtinguts_other": "{{punts}} puntos",
    "haviaRespost": "Ya habíais respondido esta pregunta.",
    "explicacio": "Explicación",
    "calVisitar": "Primero tenéis que llegar al punto para que se active la pregunta.",
    "foraDeFranja": "El evento no está activo en este momento."
  },
  "classificacio": {
    "titol": "Clasificación",
    "posicio": "Posición",
    "equip": "Equipo",
    "punts": "Puntos",
    "encerts": "Aciertos",
    "durada": "Duración",
    "senseDades": "Todavía no hay ningún equipo con puntuación.",
    "actualitzat": "Actualizado a las {{hora}}",
    "actualitzar": "Actualizar",
    "enCurs": "Evento en curso",
    "acabat": "Evento terminado",
    "vosaltres": "Vuestro equipo"
  },
  "registre": {
    "titol": "Inscripción",
    "nomEquip": "Nombre del equipo",
    "responsable": "Persona responsable",
    "telefon": "Teléfono de contacto",
    "numPersones": "Número de personas",
    "menors": "Los menores de edad deben ir acompañados de la persona adulta responsable del equipo.",
    "email": "Correo electrónico",
    "idiomaPreferit": "Idioma preferido",
    "consentimentTitol": "Protección de datos",
    "consentiment": "He leído y <destacat>acepto</destacat> el tratamiento de mis datos personales de acuerdo con la <politica>política de privacidad</politica>.",
    "consentimentDetall": "Usamos el nombre, el teléfono y el correo solo para gestionar el evento y enviaros el código QR. Los datos de contacto se suprimen pasado el plazo de conservación.",
    "enviar": "Inscribir el equipo",
    "enviant": "Enviando",
    "fet": "Inscripción completada",
    "fetDetall": "Os hemos enviado el código QR a {{email}}. También podéis empezar directamente desde este dispositivo.",
    "correuFallat": "No hemos podido enviar el correo, pero la inscripción se ha guardado. Podéis empezar desde este dispositivo o pedir el código a la organización.",
    "comencar": "Empezar el recorrido",
    "tancat": "Las inscripciones para este evento están cerradas.",
    "obligatori": "Este campo es obligatorio",
    "emailNoValid": "Escribid una dirección de correo válida",
    "telefonNoValid": "Escribid un teléfono válido",
    "personesNoValid": "Indicad como mínimo una persona",
    "consentimentObligatori": "Hay que aceptar el tratamiento de datos para continuar",
    "grupEquip": "Datos del equipo",
    "grupContacte": "Cómo os avisamos",
    "grupContacteAjuda": "Aquí recibiréis el código QR para empezar.",
    "quan": "Cuándo",
    "puntsDelRecorregut": "Puntos",
    "passos": "Cómo funciona",
    "pas1": "Rellenad el formulario y recibiréis un código QR por correo.",
    "pas2": "El día de la gymkhana, escanead el código y empieza el recorrido.",
    "pas3": "En cada punto, un vídeo y una pregunta. Solo tenéis un intento."
  },
  "peu": {
    "privacitat": "Política de privacidad",
    "credit": "Gymkhana del barrio de Hostafrancs"
  },
  "errors": {
    "titol": "Algo no ha ido bien",
    "sesion_no_valida": "La sesión no es válida. Volved a escanear el código QR.",
    "sesion_requerida": "Hay que iniciar la sesión con el código QR del equipo.",
    "evento_no_encontrado": "No hemos encontrado este evento.",
    "evento_no_activo": "Este evento no está activo.",
    "evento_fuera_de_franja": "El evento todavía no ha empezado o ya no está activo.",
    "evento_terminado": "El evento ya ha terminado.",
    "registro_cerrado": "Las inscripciones ya están cerradas.",
    "punto_no_encontrado": "No hemos encontrado este punto.",
    "punto_no_pertenece_al_evento": "Este punto no forma parte de vuestro evento.",
    "visita_no_registrada": "Primero tenéis que llegar al punto.",
    "demasiado_lejos": "Estáis demasiado lejos del punto. Os faltan unos {{distancia}} metros.",
    "pregunta_no_disponible": "Esta pregunta no está disponible.",
    "respuesta_ya_enviada": "Ya habíais enviado una respuesta.",
    "opcion_no_valida": "Esta opción no es válida.",
    "datos_no_validos": "Hay datos que no son correctos.",
    "credenciales_no_validas": "Las credenciales no son correctas.",
    "no_autorizado": "No tenéis permiso para hacer esto.",
    "demasiadas_peticiones": "Habéis hecho demasiadas peticiones seguidas. Esperad un poco.",
    "error_interno": "Ha habido un error en el servidor. Volved a intentarlo.",
    "xarxa": "No hay conexión con el servidor. Comprobad la cobertura.",
    "ruta_no_encontrada": "Esta dirección no existe.",
    "rutaTitol": "Esta página no existe",
    "rutaDetall": "La dirección que habéis abierto no corresponde a ninguna pantalla de la aplicación. Comprobad que el enlace esté entero.",
    "enllacTitol": "El enlace de acceso no es válido",
    "enllacDetall": "Este enlace está incompleto o mal copiado. Volved al correo con vuestro código QR y abridlo entero, o escanead el código con la cámara. Si no lo encontráis, pedid a la organización que os lo reenvíe.",
    "anarAlRecorregut": "Ir al recorrido",
    "correo_no_enviado": "No se ha podido enviar el correo. Revisad la configuración de correo del servidor.",
    "participante_anonimizado": "Este equipo ya no tiene dirección de correo: los datos se borraron."
  },
  "pwa": {
    "actualitzacio": "Hay una versión nueva de la aplicación",
    "actualitzar": "Actualizar ahora",
    "mesTard": "Más tarde"
  },
  "admin": {
    "titol": "Administración",
    "entrar": "Entrar",
    "sortir": "Salir",
    "email": "Correo electrónico",
    "contrasenya": "Contraseña",
    "punts": "Puntos",
    "esdeveniments": "Eventos",
    "participants": "Participantes",
    "editar": "Editar",
    "desactivar": "Desactivar",
    "actiu": "Activo",
    "inactiu": "Inactivo",
    "exportar": "Exportar CSV",
    "veureQr": "Ver el código QR",
    "nom": "Nombre",
    "descripcio": "Descripción",
    "latitud": "Latitud",
    "longitud": "Longitud",
    "radi": "Radio en metros",
    "videoUrl": "Dirección del vídeo",
    "videoDescripcio": "Descripción del vídeo",
    "subtitolsUrl": "Dirección de los subtítulos",
    "inici": "Inicio",
    "fi": "Fin",
    "pregunta": "Pregunta",
    "opcions": "Opciones",
    "respostaCorrecta": "Respuesta correcta",
    "puntsAtorgats": "Puntos otorgados",
    "explicacioBase": "Explicación base",
    "explicacioAmpliada": "Explicación ampliada",
    "afegirOpcio": "Añadir opción",
    "esborrarOpcio": "Borrar opción",
    "capPunt": "Todavía no hay puntos.",
    "capEsdeveniment": "Todavía no hay eventos.",
    "traduccioPendent": "Falta la traducción en {{idioma}}",
    "clicarMapa": "Haced clic en el mapa para situar el punto",
    "nouPunt": "Nuevo punto",
    "editarPunt": "Editar el punto",
    "nouEsdeveniment": "Nuevo evento",
    "editarEsdeveniment": "Editar el evento",
    "posicio": "Posición",
    "ordre": "Orden en el recorrido",
    "equip": "Equipo",
    "dataRegistre": "Fecha de registro",
    "obrirDetall": "Ver el detalle",
    "tancarDetall": "Ocultar el detalle",
    "detallEsdeveniment": "Detalle del evento",
    "puntsIPreguntes": "Puntos y preguntas",
    "enllacInscripcio": "Enlace de inscripción",
    "afegirPunt": "Añadir un punto al evento",
    "treureDelEsdeveniment": "Quitar del evento",
    "capPuntAlEsdeveniment": "Este evento todavía no tiene ningún punto asociado.",
    "capParticipant": "Todavía no hay ningún equipo inscrito.",
    "preguntaDe": "Pregunta de {{punt}}",
    "marcarCorrecta": "Opción {{id}} (marcadla si es la correcta)",
    "senseVideo": "Sin vídeo",
    "videoYoutube": "Vídeo alojado en YouTube: empezará sin sonido y conectará con Google.",
    "videoArxiu": "Archivo de vídeo propio: puede empezar con sonido y no depende de terceros.",
    "qrDe": "Código QR del equipo {{equip}}",
    "ajudaQr": "Mostrad este código al equipo si no les ha llegado el correo.",
    "ajudaRadi": "Con el GPS de ciudad, por debajo de 25 m cuesta que el punto se active.",
    "ajudaVideo": "Podéis pegar un enlace de YouTube o la dirección de un archivo de vídeo.",
    "ajudaVideoDescripcio": "Texto alternativo para quien no puede ver el vídeo. Es obligatorio.",
    "ajudaSubtitols": "Dirección del archivo de subtítulos en formato WebVTT.",
    "ajudaFranja": "Hora local. Las inscripciones se cierran automáticamente a la hora de fin.",
    "ajudaActiu": "Si lo desactiváis, el evento queda suspendido aunque esté dentro de la franja.",
    "ajudaExplicacio": "Se muestra siempre después de responder, se acierte o no.",
    "ajudaOrdre": "Solo ordena la lista, no obliga a seguirlo.",
    "avisSolapament": "Este punto se solapa con: {{punts}}. Los dos podrían activarse a la vez.",
    "avisOpcionsIncompletes": "Faltan textos de opciones en: {{idiomes}}. Esos idiomas no se publicarán.",
    "avisDadesPersonals": "Esta tabla contiene datos personales. No la compartáis ni hagáis capturas.",
    "falta_nom": "Hace falta el nombre como mínimo en un idioma.",
    "falta_posicio": "Hay que situar el punto en el mapa.",
    "falta_franja": "Hay que indicar la fecha de inicio y la de fin.",
    "franjaIncoherent": "La fecha de fin tiene que ser posterior a la de inicio.",
    "falta_enunciat": "Hace falta el enunciado como mínimo en un idioma.",
    "falten_opcions": "Hacen falta como mínimo dos opciones.",
    "falta_correcta": "Hay que marcar qué opción es la correcta.",
    "falten_textos_opcions": "Hay que rellenar las opciones como mínimo en un idioma entero.",
    "elMeuCompte": "Mi cuenta",
    "canviarContrasenya": "Cambiar la contraseña",
    "contrasenyaActual": "Contraseña actual",
    "contrasenyaNova": "Contraseña nueva",
    "repetirContrasenya": "Repetid la contraseña nueva",
    "ajudaContrasenya": "Como mínimo {{minim}} caracteres. Usad una que no uséis en ningún otro sitio.",
    "contrasenyaCurta": "La contraseña debe tener como mínimo {{minim}} caracteres.",
    "contrasenyesNoCoincideixen": "Las dos contraseñas nuevas no coinciden.",
    "contrasenyaRepetida": "La contraseña nueva debe ser distinta de la actual.",
    "contrasenyaCanviada": "Contraseña cambiada. Las sesiones ya abiertas siguen activas hasta que caduquen.",
    "qrCartell": "QR del cartel",
    "ajudaQrCartell": "Este código lleva al formulario de inscripción. Es igual para todo el mundo y no contiene ningún dato personal: se puede imprimir y colgar en la calle sin ningún problema.",
    "qrCartellAlt": "Código QR de inscripción a {{esdeveniment}}",
    "apuntaA": "Apunta a:",
    "descarregarQr": "Descargar para imprimir",
    "ajudaImpressio": "La imagen es de 2048 píxeles: se puede imprimir a tamaño folio sin que se vea dentada.",
    "reenviarAlEquip": "Reenviar al equipo",
    "reenviarAMi": "Enviarme una copia",
    "reenviant": "Enviando...",
    "reenviamentFet": "Enviado a {{adreca}}",
    "ajudaReenviament": "El correo del equipo va a la dirección con la que se inscribió. La copia va a la dirección de vuestra sesión de administración y lleva un aviso de que es una copia.",
    "reenviamentAnonimitzat": "Este equipo ya no tiene datos de contacto: se borraron al cumplirse el plazo de conservación. El código QR de arriba sigue siendo válido y se les puede enseñar en pantalla.",
    "veureElLloc": "Ver el sitio público",
    "qr": "QR",
    "idiomaBase": "base",
    "fontVideoPropi": "Archivo propio",
    "fontVideoYoutube": "YouTube",
    "esborrarOpcioDe": "Borrar opción {{id}}"
  },
  "diagnostic": {
    "titol": "Diagnóstico de GPS",
    "intro": "Herramienta para la prueba de campo. Mide la precisión real del dispositivo y la distancia a cada punto. No registra ninguna visita ni altera el recorrido.",
    "comencar": "Empezar la medición",
    "reiniciar": "Reiniciar los datos",
    "copiar": "Copiar los datos",
    "copiat": "Datos copiados",
    "descarregar": "Descargar CSV",
    "estatActual": "Estado actual",
    "precisio": "Precisión",
    "lectures": "Lecturas",
    "latitud": "Latitud",
    "longitud": "Longitud",
    "estadistiques": "Precisión durante la sesión",
    "millor": "Mejor",
    "mediana": "Mediana",
    "pitjor": "Peor",
    "durada": "Duración",
    "ajudaMediana": "La mediana es el valor de referencia: aguanta mejor los picos aislados que la media.",
    "distancies": "Distancia a cada punto",
    "punt": "Punto",
    "distancia": "Distancia",
    "estat": "Estado",
    "rebots": "Cambios",
    "dins": "Dentro del radio",
    "marge": "Dentro del margen del servidor",
    "fora": "Fuera",
    "senseposicio": "Todavía no hay posición.",
    "canvis": "Entradas y salidas",
    "ajudaCanvis": "Cada entrada y salida del radio. Muchos cambios seguidos en el mismo punto indican que el radio es demasiado justo para la cobertura que hay.",
    "entraA": "entra en",
    "surtDe": "sale de",
    "pantallaNoActiva": "La pantalla se puede apagar. Tocadla de vez en cuando.",
    "senseWakeLock": "Este navegador no puede mantener la pantalla encendida. No la bloqueéis."
  },
  "recorregut": {
    "antetitol": "Gymkhana #FemHistòria",
    "titol": "El barrio de Hostafrancs, calle a calle",
    "intro": "Un recorrido por los puntos con historia del barrio. En cada parada encontraréis un vídeo de la serie #FemHistòria y una pregunta que responder…",
    "progres_one": "{{fets}} de {{total}} punto",
    "progres_other": "{{fets}} de {{total}} puntos",
    "puntsAcumulats_one": "{{punts}} punto",
    "puntsAcumulats_other": "{{punts}} puntos"
  }
}
